import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getProductOrders } from 'app/entities/product-order/product-order.reducer';
import { ServiceStatus } from 'app/shared/model/enumerations/service-status.model';
import { createEntity, getEntity, reset, updateEntity } from './service-order.reducer';

export const ServiceOrderUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const productOrders = useAppSelector(state => state.productOrder.entities);
  const serviceOrderEntity = useAppSelector(state => state.serviceOrder.entity);
  const loading = useAppSelector(state => state.serviceOrder.loading);
  const updating = useAppSelector(state => state.serviceOrder.updating);
  const updateSuccess = useAppSelector(state => state.serviceOrder.updateSuccess);
  const serviceStatusValues = Object.keys(ServiceStatus);

  const handleClose = () => {
    navigate('/service-order');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getProductOrders({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    values.createdTimestamp = convertDateTimeToServer(values.createdTimestamp);

    const entity = {
      ...serviceOrderEntity,
      ...values,
      productOrder: productOrders.find(it => it.id.toString() === values.productOrder?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdTimestamp: displayDefaultDateTime(),
        }
      : {
          serviceStatus: 'NEW',
          ...serviceOrderEntity,
          createdTimestamp: convertDateTimeFromServer(serviceOrderEntity.createdTimestamp),
          productOrder: serviceOrderEntity?.productOrder?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="crawlerBackendApp.serviceOrder.home.createOrEditLabel" data-cy="ServiceOrderCreateUpdateHeading">
            <Translate contentKey="crawlerBackendApp.serviceOrder.home.createOrEditLabel">
              Create or edit a ServiceOrder
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="service-order-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.serviceOrder.startDate')}
                id="service-order-startDate"
                name="startDate"
                data-cy="startDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.serviceOrder.endDate')}
                id="service-order-endDate"
                name="endDate"
                data-cy="endDate"
                type="date"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.serviceOrder.serviceStatus')}
                id="service-order-serviceStatus"
                name="serviceStatus"
                data-cy="serviceStatus"
                type="select"
              >
                {serviceStatusValues.map(serviceStatus => (
                  <option value={serviceStatus} key={serviceStatus}>
                    {translate(`crawlerBackendApp.ServiceStatus.${serviceStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('crawlerBackendApp.serviceOrder.createdTimestamp')}
                id="service-order-createdTimestamp"
                name="createdTimestamp"
                data-cy="createdTimestamp"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="service-order-productOrder"
                name="productOrder"
                data-cy="productOrder"
                label={translate('crawlerBackendApp.serviceOrder.productOrder')}
                type="select"
              >
                <option value="" key="0" />
                {productOrders
                  ? productOrders.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/service-order"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ServiceOrderUpdate;
